// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { OrderLineDetail } from './order-line-detail';
import { Part } from './part';
import { PartLink } from './part-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrderLineDetailPart extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created?: Date;
  deleted?: Date;
  orderLineDetailId!: number;
  partId?: number;
  partLinkId?: number;
  quantity!: number;
  orderLineDetail!: OrderLineDetail;
  part!: Part;
  partLink!: PartLink;
}

